import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import appSlice from './appSlice';
import userSlice from './userSlice';
import storySlice from './storySlice';
import cleverSlice from './cleverSlice';

const isDevToolsEnabled = process.env.REACT_APP_ENABLE_REDUX_DEVTOOLS === 'true';

const combinedReducer = combineReducers({
  app: appSlice,
  user: userSlice,
  story: storySlice,
  clever: cleverSlice,
});

export const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_APP') {
    return combinedReducer(undefined, action);
  }

  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  devTools: isDevToolsEnabled
});

// Types for use throughout the app
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// Custom hooks
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
